import { IRBDItem } from "../../../../models/rbd"
import { IDiagramValues } from "../Diagram"
import finder, { SELECTOR } from "../helper/finder"
import { isElement, isParalelTransmission, isRedundantTransmission, isSerialTransmission } from "../helper/validator"
import { handleElement, handleRedundant, handleParalel } from '.'
import { handleElementParent } from "./element.handler"

export function handleSerial(current: IRBDItem, prev: IRBDItem): IDiagramValues[] {
    let result: IDiagramValues[] = [];
    
    current = finder(current, SELECTOR.TRANSMISSION_ELEMENTS)

    if (Array.isArray(current)) {
        current.map((i, x) => {
            let currentPrev: IRBDItem = (current as any)[x - 1]
            if (isElement(i)) {
                const element = handleElement(i, prev)
                if (x > 0) {
                    element.parent = handleElementParent(currentPrev)
                }
                return result.push(element)
            } else {
                if (isParalelTransmission(i)) {
                    const paralel = handleParalel(i, currentPrev)
                    if (x === 0) {
                        return alert('paralel')
                    }
                    return result.push(...paralel)
                } else if (isRedundantTransmission(i)) {
                    const redundant = handleRedundant(i, currentPrev) 
                    // handle redundant parent
                    if (x === 0) {
                        return alert('redundant')
                        //     redundant.map((ri, rx) => {
                        //         if (rx !== redundant.length - 1) {
                        //             ri.parent = prev.sequence
                        //         }
                        //     })
                    }
                    return result.push(...redundant)
                } else if (isSerialTransmission(i)) {
                    const serial = handleSerial(i, currentPrev)
                    // handle serial parent
                    if (x === 0) {
                        handleSerialParent(serial[0], prev)
                    }
                    return result.push(...serial)
                } else {
                    return undefined
                }
            }
        })
    }

    return result
}

export function handleSerialParent(serial: IDiagramValues, prev: IRBDItem) {    
    let parent: number[] = []

    if (isElement(prev)) {
        serial.parent = prev.sequence
    } else {
        const elements = finder(prev, SELECTOR.TRANSMISSION_ELEMENTS)

        if (isSerialTransmission(prev)) {
            handleSerialParent(serial, elements[elements.length - 1])
        } else if (isParalelTransmission(prev)) {
            elements.map((i:IRBDItem) => {
                if (isElement(i)) {
                    return parent.push(i.sequence) 
                } else {
                    return handleSerialParent(serial, i)
                }
            })
        } else if (isRedundantTransmission(prev)) {
            parent.push(prev.sequence)
        }
    }

    serial.parent = parent

    return serial;
}